import { Injectable, inject } from '@angular/core';

import { SharedFeaturesApiService } from '@frontend/vanilla/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * @whatItDoes Provides cashier resource methods.
 *
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class CashierResourceService {
    private api = inject(SharedFeaturesApiService);

    quickDepositEnabled(): Observable<boolean> {
        return this.api.get('cashier/quickdepositenabled').pipe(map((data) => data.enabled));
    }
}
